import { GetProductsById } from 'graphql/query';
import { useQuery } from '@apollo/client';
import { useContext, useEffect, useState } from 'react';
import { ControlContext } from 'provider/ControlProvider';
import { TrashIcon } from '@heroicons/react/24/solid';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type Props = {
  id?: string;
  quantity: number;
  variantId: string;
};

export default function CartField({
  id = 'empty',
  quantity,
  variantId,
}: Props) {
  const { priceArray, cart, setPriceArray, setCart } =
    useContext(ControlContext);
  const { data, loading } = useQuery(GetProductsById, {
    variables: { productId: id },
  });

  const [num, setNum] = useState<number>(quantity);
  const addPrice = () => {
    let tempData = cart;
    const data = {
      productId: id,
      quantity: num,
      variantId: variantId,
    };
    const index = cart.findIndex((item) => item.productId === id);
    if (index > -1) {
      tempData[index] = data;
    } else tempData = [...cart, data];
    localStorage.setItem('Cart', JSON.stringify([...tempData]));
    setCart([...tempData]);
  };
  const handleInputChange = (event: any) => {
    const { value } = event.target;
    setNum(+value.replace(/[^0-9]/g, 1)); // Replace anything other than numbers with an empty string
  };
  const removeCart = () => {
    const data = cart.filter((ele) => ele.productId !== id);
    setCart(data);
    setPriceArray([...priceArray.filter((ele) => ele.productId !== id)]);
    localStorage.setItem('Cart', JSON.stringify(data));
  };
  useEffect(() => {
    const price =
      data?.product?.variants?.edges[0]?.node?.priceV2?.amount * quantity;
    if (price > 0)
      setPriceArray([
        ...priceArray.filter((item) => item.productId !== id),
        {
          productId: id,
          quantity: price,
          variantId: variantId,
        },
      ]);
  }, [data, quantity]);
  useEffect(() => {
    addPrice();
  }, [num]);
  useEffect(() => {
    setNum(quantity);
  }, [quantity]);
  return loading ? (
    <div className='flex justify-end items-center border-t-2'>
      <div className='text-xs text-zinc-800 flex justify-start items-center w-1/2 p-2 space-x-2'>
        <Skeleton />
      </div>
      <div className='text-sm text-zinc-800 w-1/2'>
        <div className='flex justify-start items-center space-x-2'>
          <button className='px-4 py-2 hover:text-zinc-700 '>-</button>
          <input
            type='text'
            className='bg-zinc-800 w-10 text-center text-white p-2'
            value={num}
            onChange={handleInputChange}
            placeholder='0'
          />
          <button className='px-4 py-2 hover:text-zinc-700'>+</button>
        </div>
      </div>
      <div className=' text-sm text-zinc-800 h-full space-x-3 text-center w-12'>
        <Skeleton />
      </div>
      <div className='w-6'>
        <button>
          <TrashIcon className='w-6 text-zinc-700' />
        </button>
      </div>
    </div>
  ) : (
    <div className='flex justify-end items-center border-t-2'>
      <div className='text-xs text-zinc-800 flex justify-start items-center w-1/2 p-2 space-x-2'>
        <img
          src={data?.product?.images?.edges[0]?.node?.transformedSrc}
          alt={'Spore&aposs ' + data?.product?.title}
          width={40}
          height={40}
        />
        <p>{data?.product?.title}</p>
      </div>
      <div className='text-sm text-zinc-800 w-1/2'>
        <div className='flex justify-start items-center space-x-2'>
          <button
            className='px-4 py-2 hover:text-zinc-700 '
            onClick={(e) => {
              e.stopPropagation();
              if (num > 1) {
                setNum(num - 1);
              }
            }}
          >
            -
          </button>
          <input
            type='text'
            className='bg-zinc-800 w-10 text-center p-2 text-white'
            value={num}
            onChange={handleInputChange}
            placeholder='0'
          />
          <button
            className='px-4 py-2 hover:text-zinc-700'
            onClick={(e) => {
              e.stopPropagation();
              setNum(num + 1);
            }}
          >
            +
          </button>
        </div>
      </div>
      <div className=' text-sm text-zinc-800 h-full space-x-3 text-center w-12'>
        {data?.product?.variants?.edges[0]?.node?.priceV2?.amount * quantity +
          '$'}
      </div>
      <div className='w-6'>
        <button onClick={() => removeCart()}>
          <TrashIcon className='w-6 text-zinc-800' />
        </button>
      </div>
    </div>
  );
}
